/**
 * Titanoré Labs — Cart Fase 1 quantity / remove.
 * Uses native Shopify /cart/change.js and section HTML.
 */
(function () {
  if (window.__tlCartFase1) return;
  window.__tlCartFase1 = true;

  var rootSelector = ".tl-cart-fase1";

  function root() {
    return document.querySelector(rootSelector);
  }

  function changeUrl() {
    var routes = window.routes || {};
    if (routes.cart_change_url) return routes.cart_change_url + ".js";
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
    return base + "cart/change.js";
  }

  function parseJson(text) {
    try {
      return JSON.parse(text);
    } catch (e) {
      return null;
    }
  }

  function showError(message) {
    var el = document.querySelector("[data-tl-cart-error]");
    if (el) el.textContent = message || "";
  }

  function replaceSection(html) {
    if (!html) return false;
    var doc = new DOMParser().parseFromString(html, "text/html");
    var next = doc.querySelector(rootSelector);
    var current = root();
    if (!next || !current) return false;
    current.replaceWith(next);
    return true;
  }

  function replaceBubble(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, "text/html");
    var next =
      doc.getElementById("shopify-section-cart-icon-bubble") ||
      doc.querySelector(".shopify-section-cart-icon-bubble") ||
      doc.querySelector("#cart-icon-bubble") ||
      doc.querySelector(".cart-count-bubble") ||
      doc.body.firstElementChild;
    var current =
      document.getElementById("shopify-section-cart-icon-bubble") ||
      document.querySelector("#cart-icon-bubble") ||
      document.querySelector(".shopify-section-cart-icon-bubble");
    if (next && current) current.innerHTML = next.innerHTML;
  }

  function setBusy(busy) {
    var el = root();
    if (!el) return;
    el.classList.toggle("is-updating", !!busy);
  }

  function updateLine(key, quantity) {
    var el = root();
    if (!el || !key) return;
    var sectionId = el.getAttribute("data-section-id");
    var payload = {
      id: key,
      quantity: Number(quantity) || 0
    };
    var sections = [];
    if (sectionId) sections.push(sectionId);
    sections.push("cart-icon-bubble");
    payload.sections = sections;
    payload.sections_url = window.location.pathname || "/cart";

    setBusy(true);
    showError("");

    fetch(changeUrl(), {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        return res.text().then(function (text) {
          return { ok: res.ok, data: parseJson(text) };
        });
      })
      .then(function (result) {
        var data = result.data || {};
        if (!result.ok || data.errors || data.description) {
          throw new Error(data.errors || data.description || "cart");
        }
        var html = sectionId && data.sections ? data.sections[sectionId] : null;
        if (!replaceSection(html)) {
          window.location.reload();
          return;
        }
        replaceBubble(data.sections && data.sections["cart-icon-bubble"]);
        document.dispatchEvent(new CustomEvent("cart:updated", { detail: data }));
      })
      .catch(function () {
        var elNow = root();
        var fallback =
          (elNow && elNow.getAttribute("data-error")) ||
          "Cart update failed.";
        showError(fallback);
        setBusy(false);
      });
  }

  document.addEventListener("click", function (event) {
    var qtyBtn = event.target.closest("[data-tl-cart-qty]");
    var removeBtn = event.target.closest("[data-tl-cart-remove]");
    if (!qtyBtn && !removeBtn) return;
    if (!event.target.closest(rootSelector)) return;
    event.preventDefault();

    var line = (qtyBtn || removeBtn).closest("[data-line-key]");
    if (!line) return;
    var key = line.getAttribute("data-line-key");
    var input = line.querySelector("[data-tl-cart-input]");
    var current = input ? parseInt(input.value, 10) || 0 : 0;

    if (removeBtn) {
      updateLine(key, 0);
      return;
    }

    var delta = parseInt(qtyBtn.getAttribute("data-tl-cart-qty"), 10) || 0;
    var next = current + delta;
    if (next < 0) next = 0;
    if (input) input.value = String(next);
    updateLine(key, next);
  });

  document.addEventListener("change", function (event) {
    var input = event.target.closest("[data-tl-cart-input]");
    if (!input || !input.closest(rootSelector)) return;
    var line = input.closest("[data-line-key]");
    if (!line) return;
    var next = parseInt(input.value, 10);
    if (!Number.isFinite(next) || next < 0) next = 0;
    input.value = String(next);
    updateLine(line.getAttribute("data-line-key"), next);
  });
})();
